module.exports = __webpack_public_path__ + "img/yeschoose.6f9f118d.svg";